<template>
  <div class="job-card" @click="$emit('click', job)">
    <div class="job-card-header">
      <div class="title-wrapper">
        <h3 class="job-title" :title="job.title">
          {{ job.title }}
        </h3>
        <span v-if="job.recruitment_type" class="badge">
          {{
            job.recruitment_type
              ? getRecuitmenntLabel(job.recruitment_type)
              : ""
          }}
        </span>
      </div>
      <div class="job-salary">
        {{
          formatSalary(job.salary_start, job.salary_end, job.salary_month) ||
          job.salary 
        }}
      </div>
    </div>

    <div class="job-meta">
      <span>{{ getEducationLabel(job.education) }}</span>
      <span>{{ getExperienceText(job.experience) }}</span>
    </div>

    <div class="company-info">
      <div class="company-left">
        <div class="company-row">
          <img
            v-if="job.company_logo"
            class="company_logo"
            :src="job.company_logo"
            :alt="job.company_name"
          />
          <div v-else class="company-logo-placeholder">
            {{ job.company_name.slice(0, 4) }}
          </div>
          <div class="company-text">
            <div class="company-name" :title="job.company_name">
              {{ job.company_name }}
            </div>
            <div class="company-desc" :title="job.category">
              {{ job.category }}
            </div>
          </div>
        </div>
      </div>
      <div class="job-location" :title="job.city">
        {{ job.city }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatSalary,
  getEducationLabel,
  getExperienceText,
  getRecuitmenntLabel,
} from "@/constants/jobConstants";

export default {
  name: "MbtiHotJobCard",
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  emits: ["click"],
  methods: {
    formatSalary,
    getEducationLabel,
    getExperienceText,
    getRecuitmenntLabel,
  },
};
</script>

<style scoped lang="scss">
.job-card {
  width: 100%;
  min-width: 0;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 12px 32px rgba(118, 94, 228, 0.15);
  backdrop-filter: blur(18px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    border-color: rgba(124, 65, 255, 0.4);
    box-shadow: 0 18px 40px rgba(124, 65, 255, 0.2);
  }
}

.job-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.job-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.badge {
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(124, 65, 255, 0.1);
  color: #7c41ff;
  font-size: 12px;
  flex-shrink: 0;
}

.job-salary {
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  flex-shrink: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  max-width: 100%;
}

.job-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #656587;

  span {
    padding: 2px 8px;
    border-radius: 6px;
    background: rgba(101, 101, 135, 0.1);
  }
}

.company-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.company-left {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.company-row {
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.company-text {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.company-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 100%;
}

.company-desc {
  font-size: 12px;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.job-location {
  font-size: 12px;
  color: #656587;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company_logo {
  width: 34px;
  height: 34px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
}

.company-logo-placeholder {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-radius: 4px;
}
</style>
